exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);", ""]);

// module
exports.push([module.id, "*{padding:0;margin:0;box-sizing:border-box;font-family:Rubik,Segoe UI}body{display:flex;justify-content:center;align-items:center;text-align:center;width:100%;height:100vh;background-image:linear-gradient(135deg,rgba(14,51,216,.623),#1e90ff,rgba(52,2,218,.603));color:#fff;font-weight:300}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5d592a02","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 9
// module chunks = 0